<template>
  <div class="rules">
    <iot-rules-table></iot-rules-table>
  </div>
</template>

<script>
import IotRulesTable from "../components/IoTShadowRulesTable.vue";
export default {
  name: "IotRules",
  components: { IotRulesTable },
};
</script>
